import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getGravatarUrl, getInitials } from './helpers';
import * as S from './styled';

const UserAvatar = ({ name, email, size, shape = 'circle' }) => {
  const [gravatarUrl, setGravatarUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getGravatarUrl(email).then((url) => {
      if (!cancelled) setGravatarUrl(url);
    });
    return () => {
      cancelled = true;
    };
  }, [email]);

  const style = size ? { '--size': typeof size === 'number' ? `${size}px` : size } : undefined;

  return <S.Avatar initials={getInitials(name)} image={gravatarUrl} shape={shape} style={style} />;
};

UserAvatar.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  shape: PropTypes.oneOf(['circle', 'rounded', 'square']),
};

export default UserAvatar;
